import { useRequiredContext } from '#hooks/use-required-context/index.ts';
import { I18nContext } from '#providers/i18n/I18n.context.ts';
import type { TI18nContextValue } from '#providers/i18n/I18n.types.ts';

export const useI18n = (): TI18nContextValue =>
  useRequiredContext(
    I18nContext,
    'useI18n is only available inside an I18nProvider',
  );
